import { render, staticRenderFns } from "./PurchasedCourse.vue?vue&type=template&id=abebfe66&scoped=true"
import script from "./PurchasedCourse.vue?vue&type=script&lang=js"
export * from "./PurchasedCourse.vue?vue&type=script&lang=js"
import style0 from "./PurchasedCourse.vue?vue&type=style&index=0&id=abebfe66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abebfe66",
  null
  
)

export default component.exports